import React from "react";
import { DVMInputOptions } from "./types";
import { Box } from "@mui/material";

interface Props {
  venueId: string;
  onLoad?: (viewer: any) => void;
  onError?: (error: any) => void;
}

export function Map3DViewer(props: Props) {
  const containerRef = React.useRef(null);
  const DVM = window.DVM;

  React.useEffect(() => {
    if (containerRef.current) {
      const input_options = {
        container: containerRef.current,
        plugins: ["navigation"],
        // venue_id: props.venueId,
      };

      DVM.loadModule("3d_viewer", input_options)
        .then(function (viewer) {
          props.onLoad?.(viewer);
        })
        .catch(function (err) {
          console.log("Error loading DVM module:", err);
          props?.onError?.(err);
        });
    }
  }, []);

  return <Box ref={containerRef} sx={{ border: "1px solid green" }} />;
}
